import { ResponseDataGet } from "../../models/responseDataGet";
import { ResponseDataTest } from "../../models/responseDataTest";
import { agroApi } from "./api";
import { EntMovableProperty } from "../../models/movableProperty";
import { EntMovablePropertyFilter } from "../../models/filters/movablePropertyFilter";
import { BlobResponse } from "../../models/report";
import { EntRealEstateReportPayload } from "../../models/realEstateReport";
import { Paths } from "../../paths";

export const movablePropertyApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getMovablePropertyList: builder.query<ResponseDataGet<EntMovableProperty>, EntMovablePropertyFilter>({
	  query: (filter) => ({
		url: `${ Paths.registries.movableProperty }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),

	  }),
	}),
	getMovablePropertyById: builder.query<ResponseDataTest<EntMovableProperty>, number>({
	  query: (id) => ({
		url: `${ Paths.registries.movableProperty }/${ id }`,
		method: 'GET',
	  }),
	}),
	addMovableProperty: builder.mutation<ResponseDataTest<EntMovableProperty>, EntMovableProperty>({
	  query: (body) => ({
		url: `${ Paths.registries.movableProperty }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editMovableProperty: builder.mutation<ResponseDataTest<EntMovableProperty>, EntMovableProperty>({
	  query: (body) => ({
		url: `${ Paths.registries.movableProperty }`,
		method: 'PUT',
		body: JSON.stringify(body)
	  }),
	}),
	deleteMovableProperty: builder.mutation<ResponseDataTest<EntMovableProperty>, number>({
	  query: (id) => ({
		url: `${ Paths.registries.movableProperty }/${ id }`,
		method: 'DELETE',
	  }),
	}),
	reportMovableProperty: builder.mutation<BlobResponse, EntRealEstateReportPayload>({
	  query: (payload) => {
		const { periodStart, periodEnd, language, governmentAlias } = payload;

		return {
		  url: `/report/movable-property`,
		  method: "POST",
		  params: {
			periodStart,
			periodEnd,
			language,
			governmentAlias
		  },
		  body: JSON.stringify(payload),
		  responseHandler: (response) => response.blob(),
		};
	  },
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddMovablePropertyMutation,
  useDeleteMovablePropertyMutation,
  useEditMovablePropertyMutation,
  useLazyGetMovablePropertyListQuery,
  useReportMovablePropertyMutation
} = movablePropertyApi;
